"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _definitionhelpers = require("../../../utils/definitionhelpers");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- VERTICAL STACK NAV : DEFINITION --------------- ++++++++++ */


var _default = {
  name: 'VerticalStackNav',
  group: _definitionhelpers.groupNames.navs,
  props: {
    name: {
      type: 'string',
      default: 'verticalstacknav'
    },
    items: {
      type: 'array',
      default: [{
        name: 'general',
        text: 'General',
        icon: 'building',
        type: 'internal',
        action: 'dashboard/account/general',
        permitted: true,
        isActive: true
      }, {
        name: 'users',
        text: 'Users',
        icon: 'users',
        type: 'internal',
        action: 'dashboard/account/users',
        permitted: true,
        badge: 'new'
      }, {
        name: 'sites',
        text: 'Sites',
        icon: 'link',
        type: 'internal',
        action: 'dashboard/account/sites',
        permitted: true
      }, {
        name: 'ads',
        text: 'Ads.txt',
        icon: 'file',
        type: 'internal',
        action: 'dashboard/account/adstxt',
        permitted: true,
        disabled: true
      }, {
        name: 'payment',
        text: 'Payment Information',
        icon: 'credit-card',
        type: 'internal',
        action: 'dashboard/account/paymentinfo',
        permitted: true,
        processing: true
      }, {
        name: 'agreement',
        text: 'Agreement Form',
        icon: 'file-alt',
        type: 'internal',
        action: 'dashboard/account/agreementform',
        permitted: false
      }]
    }
  }
};
exports.default = _default;